export default {
      id: "open-in-new-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#open-in-new-usage",
      toString: function () {
        return this.url;
      }
    }